import { ArrowRightCircle, ChevronsRight } from "react-feather";
import { H6, P } from "../../../../../AbstractElements";
import { COMMON_WEB_DATA } from "../../../../../Data/UiKit/Modal";
import { WebDesigner, WebDesigns } from "../../../../../Constant";

const WebDesign = () => {
  return (
    <>
      <div className="large-modal-header"><ChevronsRight /><H6>{WebDesigns}</H6></div>
      <P className="modal-padding-space">We build specialised websites for companies, list them on digital directories, and set up a sales funnel to boost ROI.</P>
      <H6>{WebDesigner}</H6>
      {COMMON_WEB_DATA.map(({ title, className ,pClassName}, index) => (
        <div className={`d-flex ${className}`} key={index}>
          <div className="flex-shrink-0"><ArrowRightCircle className="svg-modal"/></div>
          <div className="flex-grow-1 ms-2"><P className={pClassName&&pClassName}>{title}</P></div>
        </div>
      ))}
    </>
  );
};

export default WebDesign;
